import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=27c80fc7&scoped=true&"
import script from "./TopBar.vue?vue&type=script&lang=js&"
export * from "./TopBar.vue?vue&type=script&lang=js&"
import style0 from "./TopBar.vue?vue&type=style&index=0&id=27c80fc7&prod&lang=less&scoped=true&"
import style1 from "./TopBar.vue?vue&type=style&index=1&id=27c80fc7&prod&lang=less&"
import style2 from "./TopBar.vue?vue&type=style&index=2&id=27c80fc7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c80fc7",
  null
  
)

export default component.exports